import type { MemoMarkingEnum } from '#shared/enums';

export function getStrategyName(strategy: MemoMarkingEnum): string {
  switch (strategy) {
    case 'GUESSING_DISCOURAGED': return 'Guessing Discouraged';
    case 'PERFECT_ANSWERS': return 'Perfect Answers';
    case 'PARTIAL_ANSWERS': return 'Partial Answers Rewarded';
    case 'SIMPLE_MARKING': return 'Simple Marking';
  }
}

export function getStrategyDescription(strategy:MemoMarkingEnum): string {
  switch (strategy) {
    case 'PARTIAL_ANSWERS': return '+1 point for each correct option selected and -1 point for each extra option selected more than the total correct answers.';
    case 'PERFECT_ANSWERS': return 'A score equal to the number of options is awarded only if all options are correct.';
    case 'SIMPLE_MARKING': return '+1 point only if all the options are correct.';
    case 'GUESSING_DISCOURAGED': return '+4 points only if all the options are correct, 0 if no option was selected, -1 point if any wrong option was selected.';
  }
}

export function getStrategyExample(strategy: MemoMarkingEnum): string {
  const exampleQuestion = 'Question: "What are the Chess pieces\' colors?"\n(Correct answers: White, Black)';
  
  switch (strategy) {
    case 'GUESSING_DISCOURAGED':
      return `${exampleQuestion}
      
If you select: White, Black
then you will receive 4 points (all correct)

If you select: White, Black, Red
then you will receive -1 point (included wrong answer)

If you select: White
then you will receive -1 points (incomplete answer)

If you select nothing
then you will receive no points`;

    case 'PARTIAL_ANSWERS':
      return `${exampleQuestion}
      
If you select: White, Black
then you will receive 2 points (1 for each correct)

If you select: White, Black, Red
then you will receive 1 point because 2-1 = 1 (2 are correct, but -1 penalty for guessing an extra answer)

If you select: White, Red
then you will receive 1 point (1 correct, only 2 answers provided, therefore no penalty)

If you select: White, Red, Blue, Green
then you will receive -1 point because 1+0-2 = -1 (1 correct, 1 wrong but not penalized, and 2 extras penalized)

You select nothing
then you will receive no points`;
    
    case 'PERFECT_ANSWERS':
      return `${exampleQuestion}
      
If you select: White, Black
then you will receive 2 points (all options must be correct)

If you select: White, Black, Red
then you will receive no points (included a wrong answer)

If you select: White
then you will receive no points (incomplete answer)

If you select nothing
then you will receive no points`;

    case 'SIMPLE_MARKING':
      return `${exampleQuestion}
      
If you select: White, Black
then you will receive 1 point (all options must be correct)

If you select: White, Black, Red
then you will receive no points (included a wrong answer)

If you select: White
then you will receive no points (incomplete answer)

If you select nothing
then you will receive no points`;
  }
}
